module.exports = __webpack_public_path__ + "img/12.49fb13a9.jpg";